export default "__VITE_ASSET__DruM7YT3__"